import customAxios from "./axiosConfig";

const SignupService = {
  checkAvailability (payload) {
    return customAxios.post(window.Urls['user_check_email_valid'](), payload)
  },
  checkHeroCode (params) {
    return customAxios.get(window.Urls['promocode_is_valid'](), { params: params })
  },
  signUp (payload) {
    const api_url = window.Urls['accounts_api_signup']()
    /**
     * company_name = serializers.CharField()
     * full_name = serializers.CharField()
     * email = serializers.EmailField()
     * password = serializers.CharField()
     * preferred_language = serializers.CharField(default='nl', required=False, allow_blank=True)
     * phone_number = serializers.CharField(max_length=30, required=False, allow_blank=True)
     * country = SerializableCountryField(allow_blank=True, required=False)
    */
    payload.platform = 'web'
   
    return customAxios.post(api_url, payload)
  },
  signUpHeroes (payload, invite_code) {
    const api_url = window.Urls['accounts_api_signup'](invite_code)
    /**
     * company_name = serializers.CharField()
     * full_name = serializers.CharField()
     * email = serializers.EmailField()
     * password = serializers.CharField()
     * preferred_language = serializers.CharField(default='nl', required=False, allow_blank=True)
     * phone_number = serializers.CharField(max_length=30, required=False, allow_blank=True)
     * country = SerializableCountryField(allow_blank=True, required=False)
    */
    payload.platform = 'web'
   
    return customAxios.post(api_url, payload)
  },
  signUpAccountants (payload) {
    const api_url = window.Urls['accountants_api_signup']()
    /**
     * company_name = serializers.CharField()
     * full_name = serializers.CharField()
     * email = serializers.EmailField()
     * password = serializers.CharField()
     * preferred_language = serializers.CharField(default='nl', required=False, allow_blank=True)
     * phone_number = serializers.CharField(max_length=30, required=False, allow_blank=True)
     * country = SerializableCountryField(allow_blank=True, required=False)
     * color NEW!
     * logo NEW!
    */

    const headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
        }
    }

    payload.platform = 'web'

    const getFormData = object => Object.keys(object).reduce((formData, key) => {
      if (Array.isArray(object[key])) {
        formData.append(key, JSON.stringify(object[key]))
      } else {
        formData.append(key, object[key])
      }
      return formData
    }, new FormData())
    const data = getFormData(payload)

    return customAxios.post(api_url, data, headers)
  },
  signUpInvite (payload) {
    const api_url = window.Urls['accounts_api_signup_invite']()
    payload.platform = 'web'
    return customAxios.post(api_url, payload)
  }
}

export default SignupService;